
import * as React from "react";
import VersionInfo from "./VersionInfo";

interface IAppFooterProps {}

const AppFooter: React.FunctionComponent<IAppFooterProps> = (props) => {
  return (
    <>
        {/* <GoAAppFooter /> */}
        <VersionInfo></VersionInfo>
    </>
  );
};

export default AppFooter;
